module.exports = new __parcel__URL__("shop_machines_bp_ice_storm_tracker_cosmetic.7b4e8d1c.png").toString();